module.exports = __webpack_public_path__ + "static/media/Settings.caccbd47.svg";